let required = false;
let reason = null;
const subscribers = new Set();
export const isClientReloadRequired = () => required;
export const clientReloadReason = () => reason;
export function requireClientReload(nextReason = 'version') {
  if (required) return;
  required = true;
  reason = nextReason;
  subscribers.forEach(listener => listener());
}
export function subscribeClientReload(listener) {
  subscribers.add(listener);
  return () => subscribers.delete(listener);
}
export function handleClientReloadError(error) {
  const body = error?.response?.data;
  if (error?.response?.status !== 409 || (body?.error?.code || body?.code) !== "MESSAGING_CLIENT_RELOAD_REQUIRED") return false;
  requireClientReload();
  return true;
}

export async function observeClientReloadError(error) {
  if (handleClientReloadError(error)) return true;
  const body = error?.response?.data;
  // Attachment requests use responseType=blob, even for JSON errors.
  if (error?.response?.status === 409 && body instanceof Blob && body.size < 65536 && typeof body.text === "function") {
    try { return handleClientReloadError({ response: { status: 409, data: JSON.parse(await body.text()) } }); }
    catch { return false; }
  }
  return false;
}
